<template>
  <div>
    <div class="shop-header">
      <div class="d-flex justify-space-between px-2">
        <div @click="drawer = true" class="d-md-none d-block pt-3">
          <v-icon class="menu-icon mt-2">mdi-menu</v-icon>
        </div>
        <div class="d-flex flex-row align-center">
          <div
            class="d-flex mx-auto mx-md-0 pointer logo-image"
            @click="$router.push('/main')"
          >
            <img src="../../assets/images/logoname.png" />
          </div>
          <div @click="drawer = true" class="nav-items d-none d-md-block px-2">
            <v-icon class="menu-icon mt-2">mdi-menu</v-icon>
          </div>
          <div class="ms-8 d-none d-md-block">
            <v-autocomplete
              v-if="$vuetify.breakpoint.mdAndUp"
              hide-details
              rounded
              single-line
              filled
              item-text="name"
              item-value="name"
              dense
              style="width: 500px"
              clearable
              clear-icon="mdi-close-circle"
              prepend-inner-icon="mdi-magnify"
              @keyup.enter="goToSearchPage()"
              v-on:keypress="isLetterOrNumber($event)"
              @click:clear="onClear"
              hide-no-data
              v-model="search"
              append-icon=""
              :items="suggestList"
              :search-input.sync="suggest"
              :search-input="suggest"
              placeholder="جستجو در نام محصولات..."
            >
              <template v-slot:item="{ props, item }">
                <router-link :to="`/productDetails/${item.id}`" target="_blank">
                  {{ item.name }}
                </router-link>
              </template>
            </v-autocomplete>
          </div>
        </div>
        <div class="d-flex align-center me-3">
          <v-menu
            :disabled="
              $route.path.search('cart') > 0 ||
              $route.path.search('purchase-process') > 0 ||
              $route.path.search('successfulPurchase') > 0 ||
              $route.path.search('unsuccessfulPurchase') > 0
            "
            v-model="cartMenu"
            :close-on-content-click="false"
            bottom
            max-height="600"
            rounded="lg"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="cart-box pt-1 ps-md-8 pointer"
                v-bind="attrs"
                v-on="on"
              >
                <div
                  class="cart-badge shopPrimary"
                  v-if="computedTotalNumber != 0 && shopToken"
                >
                  {{ computedTotalNumber }}
                </div>
                <v-icon class="card-icon">$ShopCart</v-icon>
              </div>
            </template>
            <v-card class="pa-2 cart-box" v-if="computedTotalNumber > 0">
              <div class="d-flex justify-space-between">
                <span class="mainFont--text fs-mdall pt-2"
                  >سبد خرید شما ({{ computedTotalNumber }}
                  کالا)
                </span>
              </div>
              <v-divider></v-divider>

              <!-- Cart items -->
              <div class="cart-items mb-4 w-100">
                <div v-for="(item, index) in cart" :key="index">
                  <div
                    v-if="item.amount > 0"
                    class="d-flex flex-md-row flex-column justify-space-between line-items-header"
                  >
                    <div
                      class="d-flex pointer"
                      @click="$router.push(`/productDetails/${item.id}`)"
                    >
                      <img
                        width="80"
                        style="aspect-ratio: 1 / 1"
                        :src="
                          item.pictureUrl ? item.pictureUrl : '/no-image.png'
                        "
                      />
                      <div class="d-flex flex-column ms-2">
                        <p class="mainFont--text mb-1 fs-xsmall">
                          {{ item.parentName ? item.parentName : item.name }}
                        </p>
                        <div v-if="item.discountPercentage == 0">
                          <p class="shopPrimary--text fs-small mb-0">
                            {{ Number(item.price).toLocaleString() }} تومان
                          </p>
                        </div>
                        <div v-else>
                          <div>
                            <div class="d-flex">
                              <span
                                class="red--text font-weight-bold me-1 fs-small"
                                >{{ item.discountPercentage }}%</span
                              >

                              <del class="red--text fs-small mb-0">
                                {{ Number(item.price).toLocaleString() }} تومان
                              </del>
                            </div>
                            <p
                              class="fontmain--text fs-medium mb-0 font-weight-bold"
                            >
                              {{
                                Number(
                                  ((100 - item.discountPercentage) / 100) *
                                    item.price
                                ).toLocaleString()
                              }}
                              تومان
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="operation d-flex flex-column justify-content-end ms-md-0 ms-auto"
                    >
                      <ProductCounter
                        class="operation"
                        :item="cart.filter((x) => x.id == item.id)[0]"
                        :index="cart.findIndex((x) => x.id == item.id)"
                        :usage="'menu'"
                        :cart-id="cartId"
                        @send-amount="handleAmount"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="pa-2">
                <div class="d-flex justify-content-between">
                  <span class="fs-medium font-weight-bold"
                    >مبلغ قابل پرداخت:</span
                  >
                  <span class="fs-medium font-weight-bold"
                    >{{ computedTotalPrice }} تومان</span
                  >
                </div>
                <v-btn
                  @click="
                    $router.push('/checkout/cart');
                    cartMenu = false;
                  "
                  class="purple2-mainBtn white--text mt-4"
                  height="38"
                  block
                >
                  ثبت و نهایی‌سازی سفارش
                </v-btn>
              </div>
            </v-card>
            <v-card class="pa-5 text-center cart-box" v-else>
              <img width="80" src="/empty-basket.png" />
              <p class="fs-small shopSecondary--text mb-2">
                سبد خرید شما خالی است!
              </p>
              <p class="mainFont--text fs-small font-weight-bold">
                برای مشاهده محصولات کلیک کنید:
              </p>
              <v-btn
                @click="
                  $router.push('/store/all');
                  cartMenu = false;
                "
                class="primary-borderedBtn fs-small"
                block
                height="34"
                >فروشگاه
              </v-btn>
            </v-card>
          </v-menu>
        </div>
      </div>
      <div class="mt-2 mb-2 d-block d-md-none">
        <v-autocomplete
          v-if="!$vuetify.breakpoint.mdAndUp"
          hide-details
          rounded
          single-line
          filled
          item-text="name"
          item-value="name"
          dense
          style="width: 500px"
          clearable
          clear-icon="mdi-close-circle"
          prepend-inner-icon="mdi-magnify"
          @keyup.enter="goToSearchPage()"
          v-on:keypress="isLetterOrNumber($event)"
          @click:clear="onClear"
          hide-no-data
          v-model="search"
          append-icon=""
          :items="suggestList"
          :search-input.sync="suggest"
          :search-input="suggest"
          placeholder="جستجو در نام محصولات..."
        >
          <template v-slot:item="{ props, item }">
            <router-link :to="`/productDetails/${item.id}`" target="_blank">
              {{ item.name }}
            </router-link>
          </template>
        </v-autocomplete>
      </div>
    </div>
    <v-navigation-drawer v-model="drawer" fixed temporary right>
      <v-list-item>
        <div
          class="logo-image_navbar pointer my-2"
          @click="$router.push('/main')"
        >
          <img src="../../assets/images/logoname.png" />
        </div>
      </v-list-item>
      <v-divider class="my-0"></v-divider>
      <v-list-item
        v-if="!shopToken || !mobile"
        @click="
          loginDialog = true;
          drawer = false;
        "
      >
        <v-list-item-avatar class="me-3">
          <v-icon medium class="black--text">$Login</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>
          <span class="black--text fs-medium"> ورود به حساب کاربری </span>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="$router.push('/profile')" v-if="shopToken && mobile">
        <v-list-item-avatar>
          <v-icon medium class="black--text">$BigUser</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>
          <span class="black--text fs-medium2">{{ name }}</span>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="$router.push('/profile')" v-if="shopToken && mobile">
        <v-list-item-avatar>
          <v-icon medium class="black--text">$Phone</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>
          <span class="black--text fs-medium2">{{ mobile }}</span>
        </v-list-item-title>
      </v-list-item>

      <v-divider class="my-0"></v-divider>

      <div class="px-2">
        <div
          v-for="(item, index) in navItem"
          :key="index"
          class="d-flex drawer-item pointer justify-content-start"
          :class="$route.name == item.title ? 'active' : ''"
          @click="navbarOnclick(item)"
        >
          <v-icon class="dark-icon mr-2">{{ item.icon }}</v-icon>

          <span class="fs-medium mr-2">{{ item.title }}</span>
        </div>
      </div>

      <v-expansion-panels
        light
        flat
        dir="rtl"
        class="list_navbar"
        v-model="openedPanel"
      >
        <v-expansion-panel v-for="(item, index) in menuItems" :key="index">
          <v-expansion-panel-header
            color="white"
            class="d-flex justify-content-between"
          >
            <div class="d-flex mr-2">
              <v-icon style="color: rgba(0, 0, 0, 0.54) !important"
                >mdi-book-open-variant
              </v-icon>
              <span style="min-width: 100px" class="black--text mr-4 fs-medium">
                {{ item.faName }}
              </span>
            </div>

            <v-icon color="black">mdi-chevron-left</v-icon>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-expansion-panels
              v-if="item.children && item.children.length > 0"
              light
              flat
            >
              <v-expansion-panel
                :expand="submenuOpen"
                v-for="(sub, i) in item.children"
                :key="i"
                class="me-6"
              >
                <v-expansion-panel-header
                  color="white"
                  class="d-flex justify-content-between"
                >
                  <div class="d-flex mr-2">
                    <img
                      width="24"
                      v-if="sub.logo"
                      :src="sub.logo"
                      :alt="sub.faName"
                    />
                    <v-icon
                      v-else
                      size="20"
                      style="color: rgba(0, 0, 0, 0.54) !important"
                      >mdi-book-open-variant
                    </v-icon>
                    <span
                      @click="getPublisherProducts(sub)"
                      style="min-width: 100px"
                      class="black--text mr-4 fs-small"
                      >{{ sub.faName }}</span
                    >
                  </div>

                  <v-icon v-if="sub.subLinks" color="black"
                    >mdi-chevron-left
                  </v-icon>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-if="sub.subLinks && sub.subLinks.length > 0"
                >
                  <li
                    v-for="subLink in sub.subLinks"
                    :key="subLink.link"
                    @click="getSubLink(subLink)"
                    class="mb-3 mr-5"
                  >
                    <span class="black--text pr-1 fs-small pointer">
                      {{ subLink.faName }}
                    </span>
                  </li>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-if="shopToken && mobile" class="px-4">
        <div
          v-for="(item, index) in accountItems"
          :key="index"
          class="d-flex drawer-item pointer"
          :class="$route.name == item.title ? 'active' : ''"
          @click="navbarOnclick(item)"
        >
          <div class="me-4">
            <v-icon class="dark-icon">{{ item.icon }}</v-icon>
          </div>

          <span class="fs-medium">{{ item.title }}</span>
        </div>
      </div>
    </v-navigation-drawer>

    <v-dialog v-model="loginDialog" max-width="450px" class="loginmodal">
      <Login @closeLogin="closeLogin()" />
    </v-dialog>

    <v-dialog v-model="logoutDialog" class="modal-logout" max-width="450px">
      <v-card elevation="0" color="white" class="card_logout">
        <h3>خروج از حساب کاربری</h3>
        <hr class="my-0" />
        <v-col xl="12" lg="12" md="12" sm="12" xs="12">
          <h5 class="py-4">آیا از خروج از حساب کاربری مطمین هستید؟</h5>
        </v-col>
        <div class="d-flex flex-wrap justify-space-between align-center">
          <v-col xl="3" lg="3" md="3" sm="3" xs="3" class="p-0"></v-col>
          <v-col xl="3" lg="3" md="3" sm="3" xs="3" class="py-0">
            <v-btn width="100" class="purple-mainBtn" @click="logout">
              بله</v-btn
            >
          </v-col>
          <v-col xl="3" lg="3" md="3" sm="3" xs="3" class="py-0">
            <v-btn
              width="100"
              class="red-mainBtn"
              @click="logoutDialog = false"
            >
              خیر
            </v-btn>
          </v-col>
          <v-col xl="3" lg="3" md="3" sm="3" xs="3" class="p-0"></v-col>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Login from "./Login.vue";
import ProductCounter from "./ProductCounter";
import axios from "axios";
import SearchResult from "@/views/OnlineShop/SearchResult";
import Axios from "axios";
import { mapState } from "vuex";
import { isEmpty } from "ramda";

export default {
  components: {
    SearchResult,
    Login,
    ProductCounter,
  },
  data() {
    return {
      submenuOpen: false,
      openedPanel: null,
      suggest: "",
      suggestList: [],
      name: "",
      mobile: window.localStorage.mobile,
      inSearchPage: false,
      search: "",
      drawer: false,
      publishersDrawer: false,
      loginDialog: false,
      pageLoading: false,
      cartMenu: false,
      reactivity: false,
      shopToken: "",
      cartId: "",
      mainMenu: [],
      menuItems: [],
      navItem: [
        {
          title: " صفحه اصلی",
          id: 1,
          to: "/main",
          icon: "mdi-home",
        },
        {
          title: "فروشگاه",
          id: 2,
          to: "/store/all",
          icon: "mdi-cart ",
        },
        {
          title: "تماس با ما",
          id: 3,
          to: "/contactUs",
          icon: "mdi-phone ",
        },
        {
          title: "درباره ما",
          id: 4,
          to: "/aboutUs",
          icon: "mdi-information ",
        },
      ],
      accountItems: [
        {
          title: "تنظیمات حساب کاربری",
          id: 6,
          to: "/profile",
          icon: "mdi-account",
        },
        {
          title: "خروج از حساب کاربری",
          id: 7,
          to: "/profile",
          icon: "mdi-logout",
        },
      ],
      logoutDialog: false,
      isEmpty: false,
    };
  },
  beforeUpdate() {
    this.name = window.localStorage.name;
    this.mobile = window.localStorage.mobile;
  },
  watch: {
    suggest(val) {
      if (val && val.length > 3) {
        this.getSuggests();
      }
    },
  },

  created() {
    this.getUserToken();
    this.fetchMenuData();
    this.cartId = localStorage.getItem("cartId");
    this.$store.dispatch("getCartData", {
      cartId: this.cartId,
    });
  },
  methods: {
    getSuggests() {
      Axios.get(
        this.baseUrl +
          "/onlineShop/items/search?name=" +
          this.suggest +
          "&page=1",
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.suggestList = res.data.items;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },

    onClear() {
      this.search = "";
      this.suggest = "";
    },
    isLetterOrNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[\u0600-\u06FFa-zA-Z0-9\s]+$/.test(char)) return true;
      else e.preventDefault();
    },
    goToSearchPage() {
      this.suggestList = [];
      if (this.suggest)
        if (this.$route.path.search("result") > 0) {
          this.inSearchPage = false;
          this.$router.push({
            path: "/result",
            query: { search: this.search ? this.search : this.suggest },
          });
          // this.search = "";
          this.suggestList = [];
        } else {
          this.$router.push({
            path: "/result",
            query: { search: this.search ? this.search : this.suggest },
          });
          this.inSearchPage = true;
          // this.search = "";

          this.isactivesearchWeb = false;
        }
    },
    getPublisherProducts(sub) {
      this.$router.push(`/store/${sub.link}`);
      // if (!sub.subLinks) {
      //   this.openedPanel = null;
      //   this.$router.push(`/store/${sub.link}`);
      // }
    },
    getSubLink(subLink) {
      this.openedPanel = null;
      this.$router.push(`/store/${subLink.link}`);
    },
    logout() {
      localStorage.removeItem("shopToken");
      localStorage.removeItem("mobile");
      localStorage.removeItem("name");
      localStorage.removeItem("id");
      this.$store.dispatch("removeCartItems");
      this.shopToken = null;
      // location.reload();
      this.drawer = false;
      this.logoutDialog = false;
      this.toast("خروج با موفقیت انجام شد", "success");
      this.$router.push("/main");
    },

    closeLogin() {
      this.loginDialog = false;
      this.drawer = false;
      this.getUserToken();
    },
    getUserToken() {
      this.shopToken = localStorage.getItem("shopToken");
    },
    fetchMenuData: async function () {
      this.pageLoading = true;
      await axios
        .get(this.baseUrl + "/onlineShop/home/header", {})
        .then((res) => {
          if (res.status == 200) {
            let mainMenu = res.data.mainMenu;
            for (const iterator of mainMenu) {
              iterator.children = [];
              for (const [key, value] of Object.entries(res.data)) {
                if (key.includes(iterator.name)) {
                  iterator.children = value;
                }
              }
            }
            this.menuItems = mainMenu;
            this.pageLoading = false;
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast("Error: " + err.response.data, "error");
        });
    },
    getCartData: async function () {
      this.isLoading = true;
      await Axios.get(
        this.baseUrl + "/onlineShop/cart/getData/" + this.cartId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status === 200) {
            this.cart = res.data.items;
            if (this.cart.length === 0) {
              this.isEmpty = true;
            }
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          if (err.response.status == 403 || err.response.status == 404)
            localStorage.setItem("name", "");
          else this.toast("خطا: " + err.response.data, "error");
        });
    },
    navbarOnclick(item) {
      if (item.id < 7) {
        this.$router.push(item.to);
      } else {
        this.logoutDialog = true;
      }
    },
    handleAmount(event) {
      this.item.amountInCart = event;
    },
  },

  computed: {
    ...mapState({
      cart: (state) => state.onlineShop.cart,
      isLoading: (state) => state.onlineShop.isLoading,
    }),

    //   ...mapGetters(["cartItems"]),
    computedTotalNumber() {
      return this.cart
        .map((x) => Number(x.amount))
        .reduce((a, b) => a + b, 0)
        .toLocaleString();
    },
    computedTotalPrice() {
      return this.cart
        .map((item) => item.specialPrice * item.amount)
        .reduce((a, b) => a + b, 0)
        .toLocaleString();
    },
  },

  // watch: {
  //   cartItems(val) {
  //     this.cart = val;
  //   },
  //   computedRouter(val) {
  //     if (val != "صفحه جستجو") {
  //       this.search = "";
  //     }
  //   },
  // },
};
</script>

<style lang="scss">
.v-expansion-panel-header {
  padding-right: 20px;
  padding-bottom: 12px;
}

.shop-header {
  width: 100%;
  height: 100px;
  padding: 12px 15px;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  overflow-y: hidden;
  @media only screen and (max-width: 900px) {
    height: 150px;
  }

  .menu-icon {
    font-size: 1.9rem;
    transform: translateX(-9px);
    cursor: pointer;
  }

  .logo-image {
    width: 60px;
    height: auto;
    object-fit: contain;
    @media only screen and (max-width: 1300px) {
      width: 55px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .vertcal-divider {
    max-width: none !important;
    min-height: 0px !important;
    height: 40px !important;
  }

  .login-btn {
    border: 1px solid #ccc !important;
    background-color: #fff;
  }

  .cart {
    &-box {
      position: relative;
    }

    &-icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &-badge {
      position: absolute;
      top: -3px;
      left: 16px;
      min-width: 20px;
      height: 20px;
      padding: 5px;
      border-radius: 50px;
      color: #fff;
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.8rem;
    }
  }

  .nav-items {
    display: flex;
    align-items: center;

    h1 {
      cursor: pointer;
      font-size: 15px;
      margin: 0;
      margin-right: 15px;
    }

    @media only screen and (max-width: 1300px) {
      display: none;
    }
  }
}
.line-items-header {
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}
.drawer-item {
  padding: 15px 12px;
  border-radius: 10px;

  &:hover {
    background-color: #f2eafa;
    color: #6200ea;

    path {
      stroke: #6200ea;
    }

    i {
      color: #6200ea;
    }
  }

  &.active {
    background-color: #f2eafa;
    color: #6200ea;

    path {
      stroke: #6200ea;
    }

    i {
      color: #6200ea;
    }
  }
}

.item_nav_bar_mobile {
  padding: 8px 0;
}

.items_menu_mobile {
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
    color: var(--deep-purple-accent4);
    margin-left: 5px;
  }

  span {
    color: var(--mainFont);
    font-weight: 600;
    font-size: 18px;
  }
}

.icon_men_mobile {
  display: flex;
  align-items: center;

  h1 {
    font-size: 16px;
    font-weight: 600;
    margin-right: 3px;
    color: var(--mainFont);
  }
}

.card_logout {
  padding: 20px 15px;

  h3 {
    font-size: 16px;
    font-weight: 600;
  }

  h5 {
    font-size: 14px;
    font-weight: 500;
  }
}

.icon_men_mobiles {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  h1 {
    font-size: 16px;
    font-weight: 600;
    margin-right: 3px;
    color: var(--mainFont);
  }
}

.log_user_items {
  padding: 0 20px;
}

.logo-image_navbar {
  display: flex;
  margin: 0 auto;
  width: 60px;
  height: auto;
  object-fit: contain;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.item_user_log {
  span {
    display: flex;
    align-items: center;
    color: var(--mainFont);
    font-weight: 600;
    font-size: 18px;
    text-align: right;
    cursor: pointer;
    border-bottom: 1px solid var(--deep-purple-accent4);
    padding: 8px 0;

    svg {
      width: 20px;
      height: 20px;
      color: var(--deep-purple-accent4);
      margin-left: 10px;
    }
  }
}

.btn_log_mobile {
  margin: 20px 0;
}

.wrapper_menu_mobile {
  display: flex;

  svg {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 24px;
    height: 24px;
    color: var(--deep-purple-accent4);
    cursor: pointer;
  }
}

.details_header {
  display: flex;
  justify-content: space-between;
}

.navBar_mobile {
  display: flex;
  flex-direction: column;

  li {
    display: flex;
    align-items: center;
    color: unset;
    text-decoration: none;
    color: var(--mainFont);
    font-weight: 600;
    font-size: 18px;
    text-align: right;
    cursor: pointer;

    position: relative;

    i {
      font-size: 20px;
      color: var(--deep-purple-accent4);
      margin-left: 10px;
    }

    a {
      text-align: right;

      &:hover {
        color: var(--deep-purple-accent4);
      }
    }

    &:hover {
      color: var(--deep-purple-accent4);
    }
  }
}

.root_menu {
  padding: 10px;
  position: unset;
  width: 100%;
  height: 100vh;
  overflow: visible;
  background-color: #fff;
  z-index: 9999;
}

@mixin flexBox() {
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

@mixin align-items($align) {
  -webkit-align-items: $align;
  align-items: $align;
}

@mixin justify-content($justify) {
  -webkit-justify-content: $justify;
  justify-content: $justify;
  -ms-flex-pack: $justify;
}

@mixin box-sizing($border-box) {
  -webkit-box-sizing: $border-box;
  -moz-box-sizing: $border-box;
  box-sizing: $border-box;
}

@mixin transform($transforms) {
  -moz-transform: $transforms;
  -o-transform: $transforms;
  -ms-transform: $transforms;
  -webkit-transform: $transforms;
  transform: $transforms;
}

@mixin translate($x, $y) {
  @include transform(translate($x, $y));
}

@mixin transition($transition...) {
  -moz-transition: $transition;
  -o-transition: $transition;
  -webkit-transition: $transition;
  transition: $transition;
}

.menu-mobile {
  color: var(--mainFont);
  @include flexBox();
  @include align-items(center);

  .m-menu__checkbox {
    display: none;
  }

  label.m-menu__toggle {
    cursor: pointer;
  }

  .m-menu__header {
    display: flex;
    align-items: center;
  }

  .m-menu__toggle {
    svg {
      width: 24px;
      height: 24px;
      color: var(--deep-purple-accent4);
      cursor: pointer;
    }
  }

  .m-menu {
    position: absolute;
    top: 0;
    right: 0;
    max-width: 300px;
    width: 100vw;
    height: 100vh;
    @include transform(translate3d(500px, 0, 0));
    @include transition(transform 0.35s);
    z-index: 999;
    overflow: hidden;
    background-color: var(--bgMain);
    border-left: 2px solid #a076f9;
    padding: 30px 10px;

    &__overlay {
      background-color: hsla(0, 0%, 40.4%, 0.5);
      position: absolute;
      top: 0;
      width: 100%;
      bottom: 0;
      z-index: 1;
      display: none;
    }

    &__header {
      padding: 0 16px;
      height: 40px;
      @include flexBox();
      @include align-items(center);
      border-bottom: 1px solid var(--deep-purple-accent4);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;

      h1 {
        font-size: 16px;
        font-weight: 600;
        margin-right: 3px;
        color: var(--mainFont);
      }

      span {
        font-weight: bold;
        text-align: right;
        width: 100%;
        color: #000;
        font-weight: 600;
        font-size: 14px;
      }
    }

    .m-menu {
      @include transform(translate3d(480px, 0, 0));
    }

    ul {
      height: 100%;
      overflow-y: auto;

      li {
        border-bottom: 1px solid var(--deep-purple-accent4);

        a {
          display: flex;
          align-items: center;
        }

        a,
        label {
          display: block;
          text-align: right;
          text-decoration: none;
          cursor: pointer;
          position: relative;
          color: var(--mainFont);
          font-weight: 600;
          font-size: 18px;
        }

        label,
        a {
          display: flex;
          align-items: center;
          justify-content: space-between;

          svg {
            width: 20px;
            height: 20px;
            color: var(--deep-purple-accent4);
            margin-left: 10px;
          }

          .a-label__chevron {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0;

            a {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 0;
            }
          }

          &.a-label__chevron::after {
            content: "";
            position: absolute;
            display: inline-block;
            height: 10px;
            width: 10px;
            border-color: var(--deep-purple-accent4);
            border-style: solid;
            border-width: 1px 1px 0 0;
            @include transform(rotate(-135deg));
            top: 50%;
            left: 16px;
          }
        }

        .-invisible {
          border-bottom: 0;
        }
      }
    }
  }

  .m-menu .m-menu label.m-menu__toggle {
    @include flexBox();
    border-bottom: 0;
    padding: 0;
    @include box-sizing(content-box);
  }

  /* fade in checked menu */
  .m-menu__checkbox:checked {
    ~ .m-menu__overlay {
      display: block;
    }

    ~ .m-menu {
      @include transform(translate3d(0, 0, 0));
    }
  }
}

.modal_log_out {
  height: auto;
  width: auto;
  padding: 5px 15px;

  .v-overlay__content {
    z-index: 999;
    background: var(--bgMain);
    border-radius: 8px;
  }
}

.log-out-content {
  font-weight: 600;
  font-size: 16px;
  color: var(--mainFont);
  text-align: center;
  margin: 30px 0;
}

.btn_log-out-content {
  display: flex;
  justify-content: center;
}

@media only screen and (max-width: 1024px) {
  .modal_logout {
    bottom: 20px;
  }
}
</style>
